<!-- <input type="hidden" id="custId" name="custId" value="3487"> -->

<mat-form-field [hidden]="true" fxFlex="0 0 100%" appearance="outline" [formGroup]="frmGroup" color="accent">        
    <input matInput autocomplete="off" 
    
    [formControlName]="configData.name"
     [placeholder]="configData.placeHolder" name="{{configData.name}}" [required]="configData.required"/>
</mat-form-field>

<!-- type="{{configData.type}}"  -->